import React, { useEffect, useRef, useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import moment from "moment";
import LabelField from "../../../Component/labelField";
import CustomDropdown from "../../../Component/customDropdown";
import { showErrorSnackbar } from "../../../Action/snackbarAction";
import { useDispatch } from "react-redux";
import {
  deleteShotVideo,
  getExamListNew,
  getParentCourseNew,
  getShotVideo,
  getStoryTypeList,
  updateShotVideo,
  uploadFileShort,
} from "../../../Action/courseAction";
import AdminTable from "../../../Component/adminTable";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  containSpace,
  pdf_size_1MB,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import uploadVideo from "../../../Images/upload-video.png";
import uploadedVideo from "../../../Images/uploaded-video.png";
import InputTextField from "../../../Component/inputTextField";
import { getSubExam } from "../../../Action/adminPanelAction";
import FormInputField from "../../../Component/FormInputField";
import Dropdown from "../../../Component/dropdown";
import AddMorebtn from "../../../Component/addMoreBtn";

const EditExamSrcVideo = () => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const initialBtnVal = [
    {
      btnType: "",
      btnName: "",
      btnUrl: "",
    },
  ];
  const [createBtn, setCreateBtn] = useState(initialBtnVal);
  const initialVal = {
    examName: "",
    subExamName: "",
    parentCourseVal: "",
    examList: [],
    subExamList: [],
    parentCourseList: [],
    resetExam: false,
    resetSubExam: false,
    resetParentCourse: false,
  };
  const [states, setStates] = useState(initialVal);
  const [srcVideoData, setSrcVideoData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [videoData, setVideoData] = useState(null);
  const [uploadType, setUploadType] = useState("");
  const [packageBanner, setPackageBanner] = useState("");
  const uploadOptn = [
    { _id: 1, name: "Image" },
    { _id: 2, name: "Video" },
  ];
  const urlOptions = [
    { _id: 1, name: "PDF" },
    { _id: 2, name: "Explore Course" },
    { _id: 3, name: "Watch Video" },
    { _id: 4, name: "Resource Pages" },
  ];
  const [uploadText, setUploadText] = useState("");
  const [file, setFile] = useState(null);
  const [urlType, setUrlType] = useState("");
  const [urlTypeLink, setUrlTypeLink] = useState("");
  const [resetUrlType, setResetUrlType] = useState(false);
  const [storyTypeList, setStoryTypeList] = useState([]);
  const [storyType, setStoryType] = useState("");
  const [resetStoryType, setResetStoryType] = useState(false);

  //api call
  const get_video_data = (examStreamId) => {
    let reqBody = {
      baseCourseId: examStreamId,
      examTypeId: states?.examName?._id,
    };
    if (states?.subExamName) {
      reqBody.subExamTypeId = states?.subExamName?._id;
    }
    dispatch(
      getShotVideo(reqBody, async (resp) => {
        setSrcVideoData(resp);
      })
    );
  };
  //handle functions
  const handleSubmit = (e) => {
    e.preventDefault();
    const validArray = createBtn.filter(
      (item) => item.btnType?._id && item.btnName?.trim() && item.btnUrl?.trim()
    );
    const reqBody = {
      uploadtype: uploadType?._id,
      button: validArray?.map((item) => ({
        text: item.btnName,
        url: item.btnUrl,
        urlType: item.btnType?._id,
      })),
    };
    if (imageData) {
      reqBody.uploadurl = imageData.fileUrl;
    }

    if (videoData) {
      reqBody.uploadurl = videoData.fileUrl;
    }
    dispatch(
      updateShotVideo(reqBody, editData?._id, async () => {
        setIsEdit(false);
        setImageData(null);
        setVideoData(null);
        get_video_data(states?.parentCourseVal?._id);
        setStates([initialVal]);
      })
    );
  };
  const validations = () => {
    return (
      uploadType === "" ||
      (uploadType?.name === "Image" && !packageBanner) ||
      (uploadType?.name === "Video" && !file) ||
      (urlType && !urlTypeLink) ||
      !validateButtons()
    );
  };

  const onChangeData = (value, type) => {
    if (type === "examName") {
      setStates((prevState) => ({
        ...prevState,
        examName: value,
        resetExam: false,
        resetSubExam: true,
        resetParentCourse: true,
      }));
      dispatch(
        getSubExam(
          {
            examTypeId: value._id,
          },
          (res) => {
            if (res?.data.length > 0) {
              setStates((prevState) => ({
                ...prevState,
                subExamList: res?.data,
              }));
            } else {
              dispatch(
                getParentCourseNew(`${value._id}`, (res) => {
                  setStates((prevState) => ({
                    ...prevState,
                    parentCourseList: res,
                  }));
                })
              );
            }
          }
        )
      );
    } else if (type === "subExam") {
      setStates((prevState) => ({
        ...prevState,
        subExamName: value,
        resetSubExam: false,
        resetParentCourse: true,
      }));
      dispatch(
        getParentCourseNew(`${states?.examName._id}/${value._id}`, (res) => {
          setStates((prevState) => ({
            ...prevState,
            parentCourseList: res,
          }));
        })
      );
    } else if (type === "parentCourse") {
      setStates((prevState) => ({
        ...prevState,
        parentCourseVal: value,
        resetParentCourse: false,
      }));
      get_video_data(value?._id);
    }
  };
  const convertButtons = (buttonArray) => {
    return buttonArray.map((item) => {
      const matchedType = urlOptions.find((opt) => opt._id === item.urlType);

      return {
        btnType: matchedType,
        btnName: item.text,
        btnUrl: item.url,
      };
    });
  };

  const handleEdit = (val) => {
    setIsEdit(true);
    setEditData(val);
    setStoryType(val?.videoCategory);
    setCreateBtn(convertButtons(val?.button || []));
    if (val?.uploadtype === 2) {
      setUploadType({ _id: 2, name: "Video" });
    } else if (val?.uploadtype === 1) {
      setUploadType({ _id: 1, name: "Image" });
      setPackageBanner(val?.uploadurl);
    }
    if (val?.urlType === 1) {
      setUrlType({ _id: 1, name: "PDF" });
    } else if (val?.urlType === 2) {
      setUrlType({ _id: 2, name: "Explore Course" });
    } else if (val?.urlType === 3) {
      setUrlType({ _id: 3, name: "Watch Video" });
    } else if (val?.urlType === 4) {
      setUrlType({ _id: 4, name: "Resource Pages" });
    } else {
      setUrlType(null);
    }
    setUrlTypeLink(val?.url || "");
  };
  useEffect(() => {
    dispatch(
      getStoryTypeList((res) => {
        setStoryTypeList(res);
      })
    );
  }, []);
  const handleCancelEdit = () => {
    setIsEdit(false);
    setResetUrlType(false);
    setResetStoryType(false);
    setEditData(null);
    setImageData(null);
    setVideoData(null);
  };
  const handleLogoChange = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    } else if (file.size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      reader.onloadend = () => {
        setPackageBanner(reader.result);
      };
      dispatch(
        uploadFileShort(file, async (resp) => {
          setImageData(resp);
        })
      );
      reader.readAsDataURL(file);
    }
  };
  const handleUploadType = (value) => {
    setUploadType(value);
    if (value?.name === "Image") {
      setVideoData(null);
    } else {
      setImageData(null);
    }
  };

  const handleURLType = (value) => {
    setUrlType(value);
    setUrlTypeLink("");
  };

  const onChangeUrlLink = (value) => {
    if (containSpace(value)) {
      dispatch(showErrorSnackbar("Space Not Allowed"));
    } else setUrlTypeLink(value);
  };

  const handleDelete = (value) => {
    dispatch(
      deleteShotVideo(value?._id, () => {
        get_video_data(states?.parentCourseVal?._id);
      })
    );
  };
  const onPressAdd = () => {
    setCreateBtn((prev) => {
      if (prev.length >= 2) return prev;

      return [...prev, { btnType: "", btnName: "", btnUrl: "" }];
    });
  };

  const handleClose = (index) => {
    const newArray = [...createBtn];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setCreateBtn(newArray);
  };

  const handleButtonChange = (value, field, index) => {
    setCreateBtn((prev) => {
      const updated = [...prev];
      if (field === "btnUrl") {
        value = value?.replace(/\s+/g, "");
      }
      if (field === "btnType" && typeof value === "object") {
        updated[index][field] = value;
      } else {
        updated[index][field] = value;
      }
      return updated;
    });
  };
  const validateButtons = () => {
    for (let i = 0; i < createBtn.length; i++) {
      const item = createBtn[i];

      if (!item.btnType || item.btnType === "" || !item.btnType?._id) {
        continue;
      }

      if (!item.btnUrl || item.btnUrl?.trim() === "") {
        return false;
      }

      if (!item.btnName || item.btnName?.trim() === "") {
        return false;
      }
    }

    return true;
  };

  //render functions
  const renderFirstForm = () => {
    return (
      <div className="row px-0">
        <div className="col-md-4 d-flex mb-2 align-items-center">
          <LabelField labelName={"Exam Name"} isRequired />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "examName")}
            value={states?.examName}
            options={states?.examList}
            labelName="Select Exam Name"
            reset={states?.resetExam}
            disabled={isEdit}
          />
        </div>
        {states?.subExamList?.length > 0 ? (
          <div className="col-md-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Sub Exam Name"} isRequired />
            <CustomDropdown
              setInputText={(value) => onChangeData(value, "subExam")}
              value={states?.subExamName}
              options={states?.subExamList}
              labelName="Select Sub Exam Name"
              reset={states?.resetSubExam}
              disabled={isEdit}
            />
          </div>
        ) : null}
        <div className="col-md-4 d-flex mb-2 align-items-center">
          <LabelField labelName={"Exam Stream"} isRequired />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "parentCourse")}
            value={states?.parentCourseVal}
            options={states?.parentCourseList}
            labelName="Select Exam Name"
            reset={states?.resetParentCourse}
            disabled={isEdit}
          />
        </div>
      </div>
    );
  };
  const renderListMode = () => {
    return (
      <div className="col-12 formWidth">
        <div ref={tableRef}>
          <AdminTable
            tableData={srcVideoData ? srcVideoData : []}
            pagename={"srcVideoData"}
            tableHead={[
              "S.N",
              "EXAM NAME",
              "SUB EXAM",
              "EXAM STREAM",
              "STORY TYPE",
              "TYPE",
              "IMAGE / URL",
              "ACTION",
            ]}
            edit={true}
            handleEdit={(value) => handleEdit(value)}
            handleDelete={(value) => handleDelete(value)}
          />
        </div>
      </div>
    );
  };

  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="col-md-6">
          <div className="w-100">
            <div className="d-flex mb-2 align-items-center">
              <LabelField labelName={"Story Type"} isRequired />
              <CustomDropdown
                setInputText={(value) => setStoryType(value)}
                defaultValue={storyType?._id}
                options={storyTypeList}
                reset={resetStoryType}
                labelName="Select Story Type"
                disabled={isEdit}
              />
            </div>
            <div className="d-flex mb-2 align-items-center">
              <LabelField labelName={"Upload Type"} isRequired />
              <CustomDropdown
                setInputText={(value) => handleUploadType(value)}
                defaultValue={uploadType?._id}
                options={uploadOptn}
                labelName="Select Upload Type"
              />
            </div>
            {uploadType?.name === "Image" && (
              <div className="d-flex mb-2 align-items-center">
                <ImagePickerAndViewer
                  labelName={"Upload Image"}
                  value={packageBanner}
                  handleChange={(e) => handleLogoChange(e)}
                  htmlFor={"photo-upload"}
                  isRequired
                />
              </div>
            )}
            {uploadType?.name === "Video" && (
              <>
                <div className="d-flex align-items-center me-3 mb-4 ">
                  <LabelField labelName={"Upload Video"} />
                  <label htmlFor="upVideo" className="form-label cursor">
                    {uploadText ? (
                      <img src={uploadedVideo} alt="upload-vidoe" width="80" />
                    ) : (
                      <img src={uploadVideo} alt="upload-vidoe" />
                    )}
                    <span className="d-block uvName">
                      {file ? <span>{file.name}</span> : "Upload Video"}
                    </span>
                  </label>
                  <input
                    className="form-control d-none"
                    type="file"
                    id="upVideo"
                    required
                    accept="video/*,.mkv"
                    onChange={(e) => {
                      setFile(e.target.files[0]);
                      const file = e.target.files[0];
                      if (file) {
                        const video = document.createElement("video");
                        video.preload = "metadata";
                        video.onloadedmetadata = () => {
                          window.URL.revokeObjectURL(video.src);
                        };
                        video.src = URL.createObjectURL(file);
                        dispatch(
                          uploadFileShort(file, async (resp) => {
                            setVideoData(resp);
                          })
                        );
                      }
                    }}
                  />
                  <span className="required ms-2 fs-6">*</span>
                </div>
                {!uploadText && (
                  <div className="d-flex align-items-center mb-2 ">
                    <InputTextField
                      labelName={"URL"}
                      value={editData?.uploadurl}
                      disabled
                    />
                  </div>
                )}
              </>
            )}
            <div className="col-auto">
              {createBtn?.map((item, index) => {
                const selectedValues = createBtn
                  .map((btn, i) => (i !== index ? btn.btnType : null))
                  .filter(Boolean);

                const filteredOptions = urlOptions.filter(
                  (opt) => !selectedValues.includes(opt._id)
                );

                return (
                  <div
                    key={index}
                    className="position-relative border border-1 rounded-1 p-2 mb-2"
                  >
                    <span className="d-flex justify-content-end p-2 removeButton">
                      {createBtn?.length === 1 ? null : (
                        <HighlightOffIcon
                          className="cursor"
                          color="primary"
                          fontSize="small"
                          onClick={() => handleClose(index)}
                        />
                      )}
                    </span>
                    <div className="d-flex mb-2 align-items-center">
                      <LabelField labelName={"Button Type"} />
                      <Dropdown
                        setInputText={(value) =>
                          handleButtonChange(value, "btnType", index)
                        }
                        value={item?.btnType}
                        options={filteredOptions}
                        reset={resetUrlType}
                        labelName="Select Button Type"
                      />
                    </div>
                    {item.btnType && (
                      <>
                        <div className="d-flex mb-2 align-items-center">
                          <LabelField labelName={"Button Link"} />
                          <FormInputField
                            placeholder={"Enter Button Link"}
                            setInputText={(value) =>
                              handleButtonChange(value, "btnUrl", index)
                            }
                            value={item.btnUrl}
                          />
                        </div>
                        <div className="d-flex mb-2 align-items-center">
                          <LabelField labelName={"Button Name"} />
                          <FormInputField
                            placeholder={"Enter Button Name"}
                            setInputText={(value) =>
                              handleButtonChange(value, "btnName", index)
                            }
                            value={item.btnName}
                          />
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="my-2 d-flex justify-content-end">
              {createBtn?.length < 2 && (
                <AddMorebtn
                  handleClick={onPressAdd}
                  disabled={createBtn?.length >= 2}
                />
              )}
            </div>
          </div>
          <div className="col-auto d-flex justify-content-center">
            <div className="col-auto d-flex justify-content-center mt-4">
              <button
                type="submit"
                className={`btn mb-3 submitbtn ${
                  validations() ? "btn-secondary" : "btn-primary"
                }`}
                disabled={validations()}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  };

  useEffect(() => {
    setUploadText(false);
    setStartDate(moment.utc(new Date()).format("YYYY-MM-DD"));
    setEndDate(moment.utc(new Date()).format("YYYY-MM-DD"));
    dispatch(
      getExamListNew((res) => {
        setStates((prevState) => ({
          ...prevState,
          examList: res,
        }));
      })
    );
  }, []);
  return (
    <div className="contentBox">
      <PageTitle
        name={"EDIT / DELETE"}
        isEditMode={isEdit}
        onClick={handleCancelEdit}
      />
      <div className="row formDiv m-0">
        <div className="col-12 formWidth pt-3">
          <div className="col-12">{renderFirstForm()}</div>
          {!isEdit ? renderListMode() : renderEditMode()}
        </div>
      </div>
      {/* <div className="formDiv ">
        <div className="col-12 formWidth">
          <form onSubmit={handleSubmit}>
            <div className="col-auto">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex mb-2 align-items-center">
                  <LabelField labelName={"Start Date"} />
                  <DatePicker
                    setInputText={(value) => {
                      changeDate(value, "startDate");
                    }}
                    value={startDate}
                    Isrequired={true}
                  />
                </div>
                <div className="d-flex mb-2 align-items-center">
                  <LabelField labelName={"End Date"} />
                  <DatePicker
                    setInputText={(value) => changeDate(value, "endDate")}
                    value={endDate}
                    Isrequired={true}
                  />
                </div>
                <div className="d-flex mb-2 align-items-center">
                  <LabelField labelName={"Select Exam"} />
                  <CustomDropdown
                    labelName={"Select Exam"}
                    setInputText={(value) => setExamName(value)}
                    value={examName}
                    options={examList}
                    reset={resetExam}
                    defaultValue={examName?._id}
                  />
                </div>
                <div className="col-auto d-flex justify-content-center">
                  <div className="d-flex align-items-center mb-2 pe-4">
                    <button
                      type="submit"
                      className={`btn mb-3 submitbtn ${
                        validations() ? "btn-secondary" : "btn-primary"
                      }`}
                      disabled={validations()}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {renderListMode()}
          </form>
        </div>
      </div> */}
    </div>
  );
};

export default EditExamSrcVideo;
